import axiosWithAuth from '../utils/axiosWithAuth';
import { getApiEndpoint } from '../utils/apiConfig';

export const repairmanService = {
  // Get all repairmen
  getAllRepairmen: async () => {
    try {
      const response = await axiosWithAuth().get(getApiEndpoint('repairman'));
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Error fetching repairmen:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to fetch repairmen'
      };
    }
  },

  // Get repairman by ID
  getRepairmanById: async (id) => {
    try {
      const response = await axiosWithAuth().get(getApiEndpoint(`repairman/${id}`));
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Error fetching repairman:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to fetch repairman'
      };
    }
  },

  // Add new repairman
  addRepairman: async (repairmanData) => {
    try {
      const response = await axiosWithAuth().post(getApiEndpoint('repairman'), repairmanData);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Error adding repairman:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to add repairman'
      };
    }
  },

  // Update repairman
  updateRepairman: async (id, repairmanData) => {
    try {
      const response = await axiosWithAuth().put(getApiEndpoint(`repairman/${id}`), repairmanData);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Error updating repairman:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to update repairman'
      };
    }
  },

  // Delete repairman
  deleteRepairman: async (id) => {
    try {
      await axiosWithAuth().delete(getApiEndpoint(`repairman/${id}`));
      return {
        success: true
      };
    } catch (error) {
      console.error('Error deleting repairman:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to delete repairman'
      };
    }
  }
};

export default repairmanService; 